import * as angular from 'angular';

/**
 *BTCPKP-6392 CR-U 3.5.8.2 Trader list
 *Service for Trader Lists
 */
(function () {
    'use strict';

    angular.module('app').service('traderListsService', traderListsService);
    /**
     *
     * @returns {{getCurrentTraderList: Function, setCurrentTraderList: Function,
     *  setTraderListHeading: Function, getTraderListHeading: Function, getTraderLists: Function,
     *  setTraderLists: Function, updateTraderLists: Function}}
     */
    function traderListsService() {
        var currentTraderList = {};
        var traderLists = [];
        var traderListHeading = 'Create';
        var oldTraderList = {};

        //functions which can be called from the controller
        return {
            getCurrentTraderList: function () {
                return currentTraderList;
            },
            setCurrentTraderList: function (list) {
                currentTraderList = list;
            },
            setTraderListHeading: function (heading) {
                traderListHeading = heading;
            },
            getTraderListHeading: function () {
                return traderListHeading;
            },
            getTraderLists: function () {
                return traderLists;
            },
            setTraderLists: function (lists) {
                traderLists = lists;
            },
            updateTraderLists: function (list) {
                var edit = false;
                for (var i = 0; i < traderLists.length; i++) {
                    if (traderLists[i].name === list.name) {
                        // needs to be set, otherwise the trader list will always be expanded for this list in overview
                        list.showTraders = false;
                        traderLists[i] = list;
                        edit = true;
                    }
                }
                if (!edit) {
                    traderLists.push(list);
                }
            },
            getOldTraderList: function () {
                return oldTraderList;
            },
            setOldTraderList: function (list) {
                oldTraderList = list;
            },
            SECONDARY_TRADERLIST_STILL_IN_USE:
                'SECONDARY_TRADERLIST_STILL_IN_USE'
        };
    }
})();
